// JS
(function($){

    // dropdown generic
    $('.dropdown').on('click', function(e) {
        $(this).toggleClass('is-open');
    });

    // find target out
    $(document).click(function(event) {
        var $target = $(event.target);

        if (
            !$target.closest('.dropdown').length &&
            $('.dropdown').hasClass('is-open')
        ) {
            $('.dropdown').removeClass('is-open');
        }
    });

    // Fix url con redirect x errore Newsletter
    var currentLocation = window.location.href;

    if (currentLocation.includes('/utm_source=newsletter')) {
        var replaceUri = currentLocation.replace('/utm_source=newsletter','/?utm_source=newsletter');
        window.location.replace(replaceUri);
    }

    // Related cart product
    /*if( $('.cartRelated').length != 0 ){
        $('.cartRelated__flex').slick({
            dots: false,
            arrows: false,
            infinite: true,
            speed: 300,
            autoplay: false,
            autoplaySpeed: 4000,
            slidesToShow: 5,
            slidesToScroll: 1,
            //variableWidth: true,
            responsive: [
                {
                    breakpoint: 1200,
                    slidesToShow: 4
                },
                {
                    breakpoint: 1024,
                    slidesToShow: 3
                },
                {
                  breakpoint: 768,
                  slidesToShow: 2
                },
                {
                    breakpoint: 480,
                    slidesToShow: 1
                }
            ]
        })
    }*/

})(jQuery);